import { render, staticRenderFns } from "./riqingpingjia.vue?vue&type=template&id=1216acaa"
import script from "./riqingpingjia.vue?vue&type=script&lang=js"
export * from "./riqingpingjia.vue?vue&type=script&lang=js"
import style1 from "./riqingpingjia.vue?vue&type=style&index=1&id=1216acaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports